import { GraphQLResult } from "@aws-amplify/api-graphql";

import { Resident } from "@graphql/api";
import { api } from "@redux/api";
import { Tags } from "@redux/types";
import { OperationName } from "@redux/utils/graphqlBaseOperation";

export const eventApi = api.injectEndpoints({
  endpoints: (build) => ({
    addCoverageEvent: build.mutation({
      query: (data) => {
        const operationName: OperationName = "addCoverageEvent";

        return {
          operationName,
          data,
        };
      },
      transformResponse: (response: GraphQLResult<Resident>) => response.data,
      invalidatesTags: (_res, _err, arg) => [
        { type: Tags.Resident, id: arg.residentId },
      ],
    }),
  }),
});

export const { useAddCoverageEventMutation } = eventApi;
